import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/apiService.jsx';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    
    try {
      await authService.sendOTP(email);
      setMessage('✅ OTP sent to your email! Redirecting to verification...');
      
      // Redirect to OTP verification page after 2 seconds
      setTimeout(() => {
        navigate('/verify-otp', { state: { email } });
      }, 2000);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.error || err.message || 'Failed to send OTP');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-split-box">
        <div className="login-card">
          <div className="login-card-content">
            <h2>Forgot Password</h2>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              Enter your email address and we'll send you an OTP to reset your password.
            </p>

            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <label className="input-label">Email</label>
                <div className="input-wrapper">
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="Enter your registered email"
                    disabled={loading}
                  />
                </div>
              </div>

              <button className="login-button" type="submit" disabled={loading}>
                {loading ? 'Sending OTP...' : 'Send OTP'}
              </button>
            </form>

            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <p style={{ fontSize: '12px', color: '#999' }}>
                Remember your password? <a href="/login" style={{ color: '#3b82f6', textDecoration: 'none' }}>Back to Login</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
